import { FC } from "react";
import { AppPartType } from "../../../types";
import { Input } from "antd";

type Prop = {
  appPart: AppPartType;
};
const Link: FC<Prop> = ({ appPart: { default_value } }) => {
  return <Input disabled value={default_value} />;
};

export default Link;
